/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Formik, Form as Formiker, Field as Fieldmik } from 'formik'
import { Form as FormUi, Button, Segment } from 'semantic-ui-react'
import MyJobcardType from '../apiInputComponent/myjobcardType'

import MyConditions from '../apiInputComponent/myConditions'
import MyRole from '../apiInputComponent/myRole'
import * as Yup from 'yup';
import Axios from 'axios'
import APP_CONSTANTS from '../../config/constants';
import moment from 'moment';
import ReadAxios from '../axiosComponent/read'
export const InsertApproval = () => {
    const [jobId, setjobId] = useState('')
    const [conId, setconId] = useState('')
    useEffect(() => {
        if (jobId) {
            ReadAxios({
                url: 'fleet/approvalcondition/getJCTypeApprovalCondition', readItems: {
                    jobCardTypeId: jobId
                }
            })
                .then((result) => {
                    if (result?.length > 0) {
                        setconId(result[0].conditionId)
                    } else {
                        setconId([])
                    }
                })
        }
    }, [jobId])
    const validateSchema = Yup.object({
        jobcardType: Yup.string().required(),
        role: Yup.string().required(),
        startValue: Yup.number('Invalid Characters').min(0).required('Required'),
        endValue: Yup.number().when('startValue', (startValue, schema) => (startValue === null ? schema.typeError('Only Numbers Required') : schema.min(startValue + 1, 'Should be more than Start Value'))).required('Required'),
        condition: Yup.string().required('Condition Required'),
    })
    return (
        <Formik
            initialValues={{
                jobcardType: '',
                role: '',
                startValue: '',
                endValue: '',
                condition: '',
            }}
            validationSchema={validateSchema}
            validateOnChange={true}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true)
                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNo')
                let startValue = values.startValue //? values.startValue : moment(values.startDate).format('DD-MM-YYYY')
                let endValue = values.endValue //? values.endValue : moment(values.endDate).format('DD-MM-YYYY')
                let condition = values.condition
                let role = values.role
                let jobCardTypeId = values.jobcardType
                let content = JSON.stringify
                    ({
                        api_token: token,
                        jobCardTypeId: jobCardTypeId,
                        conditionId: condition,
                        startValue: startValue,
                        endValue: endValue,
                        roleId: role,
                        customerNo: customerNo,
                        userId: userId
                    })
                Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/approvalcondition/create`, content, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "Authorization": localStorage.getItem('apiToken')
                    }
                }).then(resp => {
                    if (resp.data.status === 1) {
                        window.location.href = '/approval-condition'
                    } else {
                        setSubmitting(false)
                        alert(resp.data.message)
                    }
                })
            }}
        >

            {({ values, errors, touched, isSubmitting }) => {
                if (values.jobcardType) {
                    setjobId(values.jobcardType)
                }
                let handleCondition = (e, data) => {
                    setconId(data.value)
                }
                values.condition = conId
                return (<Formiker>
                    <div className="m-2">
                        <Segment>
                            <div className="ui form tiny">
                                <FormUi.Group inline>
                                    <FormUi.Field width={3}>
                                        <label>Jobcard Type</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik autoComplete="off" style={{ width: '100%' }} component={MyJobcardType} name="jobcardType" type="condition" />
                                        {errors.jobcardType && touched.jobcardType ? (<div className="w3-tiny w3-text-red p-bold-600 m-1">{errors.jobcardType}</div>) : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width={1} />
                                    <FormUi.Field width={3}>
                                        <label>Condition</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik disabled={true} id="condition" configId={conId} onChange={handleCondition} autoComplete="off" className="disabledField" style={{ width: '100%' }} value={values.condition} component={MyConditions} name="condition" />
                                        {errors.condition && touched.condition ? (<div className="w3-tiny w3-text-red p-bold-600 m-1">{errors.condition}</div>) : ''}
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group inline>
                                    <FormUi.Field width={3}>
                                        <label>Start Value</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        {/* {values.condition === 1 ?
                                            <DateData
                                                name="startDate"
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Start Date"
                                                selected={values.startDate}
                                                selectsStart
                                                startDate={values.startDate}
                                                endDate={values['endDate']}
                                                timeIntervals={5}
                                                customInput={<Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            : */}
                                        <Fieldmik type="number" autoComplete="off" name="startValue" placeholder="Start Value" />
                                        {/* } */}
                                        {errors.startValue && touched.startValue ? (<div className="w3-tiny w3-text-red p-bold-600 m-1">{errors.startValue}</div>) : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width={1} />
                                    <FormUi.Field width={3}>
                                        <label>End Value</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        {/* {values.condition === 1 ?
                                            <DateData
                                                name="endDate"
                                                selected={values.endDate}
                                                selectsEnd
                                                startDate={values['startDate']}
                                                endDate={values.endDate}
                                                minDate={values['startDate']}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                timeIntervals={5}
                                                customInput={<Input autoComplete="off" icon="time" className="dateWidth" iconPosition="left" />}
                                            />
                                            : */}
                                        <Fieldmik type="number" autoComplete="off" name="endValue" placeholder="End Value" />
                                        {/* } */}
                                        {errors.endValue && touched.endValue ? (<div className="w3-tiny w3-text-red p-bold-600 m-1">{errors.endValue}</div>) : ''}
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group inline>
                                    <FormUi.Field width={3}>
                                        <label>Role</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik autoComplete="off" style={{ width: '100%' }} component={MyRole} name="role" />
                                        {errors.role && touched.role ? (<div className="w3-tiny w3-text-red p-bold-600 m-1">{errors.role}</div>) : ''}
                                    </FormUi.Field>
                                    <FormUi.Field />
                                </FormUi.Group>
                            </div>
                        </Segment>
                        <center><Button disabled={isSubmitting} type="submit" size="mini" color='blue'>Submit</Button></center>
                    </div>
                </Formiker>
                )
            }
            }

        </Formik>
    )
}
